import HCaptcha from "@hcaptcha/react-hcaptcha";
import Footer from "components/layout/footer";
import Loader from "components/loader";
import SEO from "components/seo";
import { Link } from "gatsby";
import { useFetchComments } from "hooks/Comments/useFetchComments";
import { usePostComments } from "hooks/Comments/usePostComments";
import OptimizedImage from "hooks/OptimizedImage";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Form from "../Form";
import FormMobile from "../FormMobile";
import Social from "../Social";
import TranslatorHubHeader from "../TranslatorHubHeader/TranslatorHubHeader";


const Index = (props) => {
  const [value, setValue] = useState(false);
  const [token, setToken] = useState(false);
  const [formStatus, setForStatus] = useState(false);
  const [hasLoadedFromScript, setHasLoadedFromScript] = useState(false);

  const captchaRef = useRef(null);

  const {
    pageContext: {
      data: { data },
    },
  } = props;

  const project_id = data.seo_project_id;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { data: dataOne, isFetching, fetchNextPage, hasNextPage } = useFetchComments(project_id);

  const { status, mutateAsync } = usePostComments();

  const onSubmit = (data) => {
    if (token) {
      const postData = {
        name: data.name,
        email: data.email,
        content: data.content,
        seo_project_id: project_id,
        notification: value,
      };
      mutateAsync(postData).then((_) => {
        reset();
        setForStatus(true);
      });
    } else {
      alert("Please verify captcha");
    }
  };

  const handleChange = (e) => {
    const { checked } = e.target;
    setValue(checked);
  };

  const handleVerify = () => {
    setToken(true);
  };

  const scriptAlreadyExists = () => document.querySelector("script#alert-script") !== null;

  const appendDynamicFormSubmitScript = () => {
    var inlineScript = document.createTextNode(
      "function handleForm(){var email=document.getElementById('midemail').value;const response=fetch('https://admin.tomedes.com/api/v1/submit-subscribe',{method:'POST',body:JSON.stringify({'email':email}),headers:{'Content-Type':'application/json'}}).then(data=>{return data.json();}).then(resp=>{if(resp.success===1){document.getElementById('midemail').value='';document.getElementById('orangeForm').style.display='none';document.getElementById('orangeThankyou').style.display='block';document.getElementById('closeThankyou').addEventListener('click',function(){document.getElementById('orangeThankyou').style.display='none';document.getElementById('orangeForm').style.display='block';})}else{}});}"
    );
    const script = document.createElement("script");
    script.id = "alert-script";
    script.async = true;
    script.appendChild(inlineScript);
    setHasLoadedFromScript(true);
    document.body.append(script);
  };

  useEffect(() => {
    if (!scriptAlreadyExists()) {
      appendDynamicFormSubmitScript();
    }
  }, []);

  useEffect(() => {
    if (hasLoadedFromScript === true) {
      let ul = document.getElementsByTagName("p")[10];
      // const form =
      //   "<div id='hubmidform' class='formStart bg-subscribe-letter bg-no-repeat bg-cover h-[520px] sm:h-[412px] lg:h-auto custom-h-form mt-10 mb-8' style='object-fit:contain;'> <form class='rightform py-[30px] px-3 lg:px-[40px]' style='padding-bottom:55px' id='rightform' onsubmit='handleForm();return false'><div class='blog-middle-form '><p class='h2head font-bold' style='color:white; font-size:30px; ' > Broaden Your Horizons <br> With International Strategy <br> and Local Knowledge</p><p class='p-10' style='color:white; font-size:20px; margin-left:-35px; padding-bottom:2px'> Subscribe to Our Business Newsletter!</p><div class='row'><div class='col-md-7 col-xs-12 f-align pl-0'><div class='form-group flex lg:flex-row flex-col text-left d-in-block' style='display:flex;'> <input value='' autocomplete='off' class='email  pl-10  w-full lg:w-[50%] text-xs italic font-semibold form-control mid-t-wide d-in-block text-left' style='height:40px;padding-left:0.5em;width:100%;'  name='midemail' id='midemail' type='text' placeholder='Enter your business email' /><div class='col-md-3 col-xs-12'><div class='text-center m-t28'> <button type='submit' class='mid-blue-submit lg:mt-0 mt-6 flex justify-start' style='background:#001546; justify-content: center; color:white; padding:6px 25px;'>SUBMIT</button></div></div> <div class=' left newsletter r-alert' id='mshowemail1'></div><div class=' left newsletter r-alert' style='color:red;' id='mshowemail'></div><div class='left newsletter g-alert' id='mshowemail2'></div><div class='left newsletter r-alert' id='mshowemail3'></div> </div> <input type='hidden' name='csrf_token' id='csrf_token' value='' /></div></div></div></div></form><div id='mid-ms-msg'></div>";

      const form =
        "<div id='orangeForm' class='orangeForm classImp w-full bg-orangeFormBgMobile sm:bg-orangeFormBgDektop bg-cover bg-center py-11 px-6 sm:px-11  text-white mt-10 mb-8'><h2 class='font-secondary text-white text-17 sm:text-[33px] font-bold text-center sm:text-left'><span class='block'>Broaden Your Horizons</span><span class='block'>With International Strategy</span><span class='block'>and Local Knowledge</span></h2><p class='font-opensans font-semibold text-14 sm:text-[20px] text-left my-5'>Subscribe to Our Business Newsletter!</p><form  onsubmit='handleForm();return false' class='flex flex-col sm:flex-row gap-3'><input type='text' name='midemail' id='midemail' placeholder='Please enter a valid business email' class='text-black font-opensans font-light px-2 py-2 w-full md:w-8/12 2xl:w-5/12' /><button type='submit' class='bg-[#001546] hover:bg-[#0032A7] font-opensans font-semibold text-14 text-[#E6E6E6] py-2 px-8 transition-colors duration-300'>Submit</button></form></div><div id='orangeThankyou' class=' hidden w-full thankyou classImp2 bg-orangeFormBgMobile sm:bg-orangeFormBgDektop bg-cover bg-center py-20 sm:py-24 px-8 sm:px-11  text-white mt-10 mb-8'><h2 class='font-secondary text-[32px] sm:text-46 font-bold mb-5 text-center sm:text-left'>Thank you!</h2><p class='font-opensans font-semibold text-17 sm:text-[20px] text-center sm:text-left my-5'>Please check your inbox for a confirmation email.</p><button id='closeThankyou' class='bg-[#001546] hover:bg-[#0032A7] font-opensans font-semibold text-14 text-[#E6E6E6] py-2 px-8 transition-colors duration-300 sm:hidden w-full'>Close</button></div>";
      ul.innerHTML += form;
    }
  }, [hasLoadedFromScript]);

  return (
    <React.Fragment>
      <TranslatorHubHeader title={"Translator's Blog"} />
      <SEO title={data.seo_project_title || data.title_x || data.seo_h1} description={data.seo_project_meta_desc} keywords={data.seo_project_meta_keywords} slug={data.slug} />
      <div className="w-11/12 sm:w-10/12 md:w-11/12 md:px-3 md:max-w-2xl lg:max-w-none xl:max-w-7xl  mx-auto lg:w-full xl:pl-[150px]">
        <div className="flex flex-col lg:flex-row lg:gap-20">
          <div className=" col-span-2">
            <h1 className="text-[28px] pb-6 text-blackNew-600 font-semibold mt-10">{data.seo_h1}</h1>
            <div className="my-6">
              <span className="text-blackNew-700">by</span>{" "}
              <Link to="https://www.linkedin.com/in/ofertirosh/" target="_blank">
                <span className="text-lightBlue font-bold">OFER TIROSH</span>
              </Link>{" "}
              <i className="text-blackNew-700">{moment(data.seo_project_create_date).format("DD/MM/YYYY")}</i>
            </div>
            <OptimizedImage
                      src={data.cover_image}
                      alt={data.seo_h1}
                      className="w-full xl:w-full  object-cover h-auto lg:h-[370px] max-h-80 mb-6"
            />
            <div className="mb-4 translator_hub_details [p:nth-child(3n+1)] " dangerouslySetInnerHTML={{ __html: data.seo_project_content }} />

            <div className="hidden sm:block lg:hidden py-3">
              <Form marginX="0" />
            </div>
            <div className="sm:hidden">
              <FormMobile marginX="0" />
            </div>
            <div className="flex items-center justify-items-center flex-col border-t-2 border-blackNew-800 mt-6 py-4">
              <span className="text-left w-full text-[22px] font-bold">
                <i className="text-orange">YOU MAY </i>
                <i className="text-blackNew-700">ALSO LIKE</i>
              </span>
              <div className="flex flex-col sm:flex-row sm:w-10/12 mr-auto gap-x-8">
                {data?.you_may_also_like.map((node, index) => (
                  <div className="mt-5" key={index}>
                    <Link to={node.slug}>
                      <OptimizedImage
                                src={node.cover_image}
                                alt={node.alt}
                                className="min-w-[315px] min-h-[196px]  object-cover mb-6"
                      />
                    </Link>
                    <Link to={node.slug}>
                      <i className="text-blackNew-900 w-full">{node.title}</i>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
            <div className="commentBar pt-4  border-t-2 border-blackNew-800 mt-4">
              <h4 className="font-semibold text-xl">
                <span className="text-orange">Post</span> your Comment
              </h4>
              {dataOne?.pages.map((page) =>
                page.data.map((c, i) => (
                  <div className="comments pt-6" key={i}>
                    <div className="commentBox max-w-max bg-[#f2f3f5] rounded-lg p-3">
                      <h2 className="font-medium text-lg capitalize">
                        <span>{c?.name}</span>
                      </h2>
                      <p>
                        <span>{c?.content}</span>
                      </p>
                      <span className="text-ligtBlue" style={{ color: "#3a7aff" }}>
                        {c?.created_date}
                      </span>
                    </div>
                  </div>
                ))
              )}

              {hasNextPage && (
                <div className="loadMoreBtn pt-6">
                  <button onClick={fetchNextPage} className="border rounded-lg px-3 py-2 text-white text-sm bg-[#5bc0de] cursor-pointer">
                    {isFetching ? <Loader /> : "Load more"}
                  </button>
                </div>
              )}
            </div>

            <div className="formInfo py-6">
              {formStatus ? (
                <span className="text-[#5C90F7]">
                  <i>Thank you! Your comment will be published as soon as possible.</i>
                </span>
              ) : (
                <></>
              )}
              <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
                <input
                  type="text"
                  className="border border-gray rounded-md p-1 pl-4 "
                  style={{ borderColor: errors.name ? "#DD5451" : "" }}
                  placeholder="Name"
                  name="name"
                  autoComplete="off"
                  {...register("name", { required: true })}
                />

                <input
                  type="text"
                  className="border border-gray rounded-md p-1 pl-4 my-4"
                  placeholder="Email (never display)"
                  name="email"
                  style={{ borderColor: errors.email ? "#DD5451" : "" }}
                  autoComplete="off"
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Enter a valid e-mail address",
                    },
                  })}
                />
                <textarea
                  cols="30"
                  rows="10"
                  className="border border-gray pl-4"
                  placeholder="Comment"
                  style={{ borderColor: errors.content ? "#DD5451" : "" }}
                  name="content"
                  {...register("content", { required: true })}
                ></textarea>
                <div className="notification flex my-4 items-center gap-x-4">
                  <input type="checkbox" onChange={(e) => handleChange(e)} defaultChecked={value} />
                  <p>I want to receive a notification of new postings under this topic</p>
                </div>
                <HCaptcha sitekey="b6b06718-08ae-457f-a6d7-147046b4c216" onVerify={handleVerify} ref={captchaRef} />
                <button type="submit" className="border rounded cursor-pointer border-black bg-black p-2.5 px-6 mt-10 text-white text-sm w-24">
                  {status === "loading" ? <Loader /> : "SUBMIT"}
                </button>
              </form>
            </div>
          </div>
          <div className="w-full  ml-0 mt-10 md:mt-0 px-4 lg:pl-0 ">
            <div>
              <h5 className="font-bold text-newGray text-new mt-4 lg:mt-10">CATEGORIES</h5>
              <ul className="text-newGray">
                {props.pageContext.uniqueCategories.map((link, index) => (
                  <li className="text-new py-2  hover:text-newLightBlue cursor-pointer" key={index}>
                    <Link to={`/translator-hub.php/category/${link}`}>{link}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="line border-b border-gray mt-12"></div>
            <div className="hidden lg:block">
              <Form marginX="0" />
            </div>
            <Social />
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};
export default Index;
